import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as animationHelper from "../../../helpers/animationHelper";

class Document extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            document: {},
            screenStatus: "",
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            continue_label: appHelper.getLocaleString("continue_label")
        };
        this.getAssets = this.getAssets.bind(this);
        this.show = this.show.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.setClass = this.setClass.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.getFilePath = this.getFilePath.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.onRendered = this.onRendered.bind(this);

        this.objectRef = React.createRef();

    }

    componentDidMount() {
        this.getAssets();
        this.getScreenStatus();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if(this.state.lang !== nextProps.lang){
            let document = appHelper.getDocumentAsset(this.state.screenObject);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document,
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate() {

    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE || this.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {

        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
            this.onComplete();
        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else if (this.state.isResourceObject) {
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }

            if (!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE});
                this.onComplete();
            }

        }

    }

    getAssets() {
        let document = appHelper.getDocumentAsset(this.state.screenObject);
        this.setState({document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document });

    }

    show() {
        let objectRef = this.objectRef.current;

        if(appHelper.isObjectEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: this.onRendered
            };
            animationHelper.showHeight(params);
        }
    }

    onRendered() {
        if (this.state.isResourceObject) {
            this.props.callbacks.onObjectRendered();
        }
        this.getObjectStatus();
    }

    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let objectRef = this.objectRef.current;
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isEleDefined(objectRef) && appHelper.isDefined(scrollTo)) {
                    scrollTo(objectRef.offsetTop, true);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    getFilePath(src) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(src) && src.length > 0) {
                return require(`../../../../moveToDist/${src}`);
            }
        } else {
            return src;
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    onOpen() {
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_COMPLETE});
            this.onComplete();
        }
        if(localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2){
            this.props.actions.setDocumentAccessed(this.state.screenObject.asset_id,this.state.locale.label);
        }
    }

    setClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        } else {
            return "not-started";
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
            if (!hasNextObject && !this.state.isResourceObject) {
                this.handleProgression();
                this.enableProgression();
            } else if (!hasNextObject && this.state.isResourceObject) {
                this.handleProgression();
            } else if (this.state.isResourceObject) {
                this.handleProgression();
            } else {
                this.enableProgression();
            }

        } else {
            this.handleProgression();
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    render() {
        return (
            <div className="a-c" ref={this.objectRef}>
                <div className="object-container">
                    <div className={`document-panel file `}>
                        <div className="flex-item">
                            <div className="document-header">
                                <div className={`link-title file ${this.setClass()}`}>
                                    <a href={this.getFilePath(this.state.document.src)}
                                       target="_blank"
                                       onClick={this.onOpen}
                                       tabIndex={0}
                                       dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                </div>
                            </div>
                            {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                ?
                                <div className="document-description"
                                     dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                : null
                            }
                        </div>

                    </div>
                    {this.state.showProgressionButton
                        ? <Button label={this.state.continue_label}
                                  id={`${this.state.screenObject}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }
                </div>
            </div>

        );
    }
}

Document.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

Document.contextTypes = {
    router: PropTypes.object
};

/*
* <ParagraphText screenObject={this.state.screenObject}
                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
                                   id={`${this.state.screenObject}_description`}
                                   class_name="document-description"
                                   objectKey={`description`}/>*/

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Document);



/** WEBPACK FOOTER **
 ** ./src/components/objects/document/Document.js
 **/